module.exports = __webpack_public_path__ + "img/student-grand-prize-cn.b2c65d1.png";